import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public isAuthorized = false;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit() {
    this.auth.userIsSuperUser.subscribe((superUser: boolean) => {
      if(superUser) {
        this.isAuthorized = true;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/admin/admin.component.ts